module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "advert-type"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("信息流广告")]), _vm._v(" "), _c('div', {
    staticClass: "advert-content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "advert-item",
    on: {
      "click": function($event) {
        return _vm.toAdvertManage(0)
      }
    }
  }, [_vm._v("动态")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "advert-item",
    on: {
      "click": function($event) {
        return _vm.toAdvertManage(1)
      }
    }
  }, [_vm._v("文章")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "advert-item",
    on: {
      "click": function($event) {
        return _vm.toAdvertManage(2)
      }
    }
  }, [_vm._v("话题")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79ce0c6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/advert/advertType.vue
// module id = 1082
// module chunks = 0